import { createReducer } from '@reduxjs/toolkit'
import { DictT, CustomerT } from 'types/model'
import { clear, logout, receiveCustomers } from 'model/actions'

const initialState = {} as DictT<CustomerT>

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveCustomers, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
